import {SvgIcon, SvgIconProps} from '@mui/material'
import React from 'react'

import {ReactComponent as CementMillIconSvg} from '../../assets/icons/CementMill.svg'

export const CementMillIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon component={CementMillIconSvg} {...props} />
)
